import { render, staticRenderFns } from "./PortalEventForm.vue?vue&type=template&id=f889bff0&lang=pug"
import script from "./PortalEventForm.vue?vue&type=script&lang=js"
export * from "./PortalEventForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports